<!--suppress ALL -->

<template>
	<tr>
		<td>
			<v-btn @click="open(client)" small icon text>
				<v-icon v-if="!isOpen">mdi-chevron-down</v-icon>
				<v-icon v-else>mdi-chevron-up</v-icon>
			</v-btn>
		</td>
		<td class="text-xs-center">
			{{client.name }}
		</td>

		<td class="text-xs-center">
			{{client.num }}
		</td>
		<td class="text-xs-center">
			{{client.price }}
		</td>
		<td class="text-xs-center">
			{{client.next_price }}
		</td>
		<td class="text-xs-center">
			{{client.branches.length }}
		</td>
    <td class="text-xs-center">
      <a v-if="client.outside_link" :href="client.outside_link" target="_blank">{{ client.outside_link }}</a>
		</td>

		<td>
			<v-btn fab small color="white" @click="addBranch" :title="$t('pages.projectForm.branch')">
				<v-icon color="#BDBDBD" dark>add</v-icon>
			</v-btn>
			<edit-btn @click="onEdit" :tooltip-text="$t('attributes.edit')"/>
			<remove-btn :tooltip-text="$t('attributes.remove')"/>
      <v-btn v-if="isAdmin" @click="createApiKey" color="success" >יצירת הוראות API</v-btn>

    </td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/Client.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "client-row",
		props: {
			client: {required: true},
			isOpen: {default: false},
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "client")],
		data() {
			return {};
		},
		computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
		methods: {
			getBranchField(field) {
				return this.client.length ? this.client[0][field] : "";
			},
			open(item) {
				this.$emit("open", item);
			},

			doRemove() {
				this.$store.dispatch(types.REMOVE, this.client).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.client);
			},
			addBranch() {
				this.$emit("branch", this.client);
			},
      createApiKey(userId) {
        swal.fire({
          icon: "warning",
          title: "שים לב!",
          text: "יצירת מחדש תמחק את המפתחות הקודמים",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          preConfirm: async (result) => {
              window.location.href = `/secrets/clients/${this.client.id}`;
              // or: window.location.assign(`/api/secrets/clients/${this.client.id}`);
            },
          allowOutsideClick: false
        })
      }
		}
	};
</script>

<style scoped>

</style>
